import { useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from "clsx";

// --- Utility: Find navigation item by URL ---
function getNavigationItem(url, navigationItems) {
  if (!navigationItems || !Symbol.iterator in Object(navigationItems))
    return null;
  for (const item of navigationItems) {
    if (item.url === url) return item;
    if (item.children) {
      const child = getNavigationItem(url, item.children);
      if (child) return child;
    }
  }
  return null;
}

// --- Utility: Build breadcrumb segments from path ---
function buildCrumbs(pathname, navigation) {
  const segments = pathname.split("/").filter(Boolean);
  const crumbs = [];

  let accumulated = "";
  for (let i = 0; i < segments.length; i++) {
    accumulated += `/${segments[i]}`;
    const navItem = getNavigationItem(accumulated, navigation);
    const title = navItem?.title || segments[i].replace(/-/g, " ");
    crumbs.push({ title, url: accumulated });
  }

  // Optional: Add root "Home"
  crumbs.unshift({ title: "Home", url: "/" });

  return crumbs;
}

export default function PageBreadcrumb({ className }) {
  const location = useLocation();
  const navigation = useSelector((state) => state.navigation);
  const crumbs = buildCrumbs(location.pathname, navigation);

  return (
    <nav
      className={clsx(
        "flex items-center text-sm text-gray-500 flex-wrap gap-1",
        className
      )}
      aria-label="breadcrumb"
    >
      {crumbs.map((item, idx) => {
        const isLast = idx === crumbs.length - 1;
        return (
          <div key={idx} className="flex items-center gap-1">
            {!isLast ? (
              <>
                <Link
                  to={item.url}
                  className="font-medium capitalize hover:text-blue-600 transition-colors"
                >
                  {item.title}
                </Link>
                <span className="text-gray-400">/</span>
              </>
            ) : (
              <span className="font-semibold text-gray-800 capitalize">
                {item.title}
              </span>
            )}
          </div>
        );
      })}
    </nav>
  );
}

// import { useLocation, Link, matchPath } from "react-router-dom";
// import Breadcrumbs from "@mui/material/Breadcrumbs";
// import Typography from "@mui/material/Typography";
// import clsx from "clsx";
// import { useSelector } from "react-redux";

// // Utility: find navigation item by URL (same as your getNavigationItem)
// function getNavigationItem(url, navigationItems) {
//   if (!navigationItems || !Symbol.iterator in Object(navigationItems)) {
//     return null;
//   }
//   for (const item of navigationItems) {
//     if (item.url === url) {
//       return item;
//     }
//     if (item.children) {
//       const child = getNavigationItem(url, item.children);
//       if (child) return child;
//     }
//   }
//   return null;
// }

// // Utility: break the pathname into parts and build breadcrumb URLs
// function buildCrumbs(pathname, navigation) {
//   const segments = pathname.split("/").filter(Boolean); // e.g. ["apps", "e-commerce", "products"]
//   const crumbs = [];

//   let accumulated = "";
//   for (let i = 0; i < segments.length; i++) {
//     accumulated += `/${segments[i]}`;
//     // Try to find a navigation item for this accumulated URL
//     const navItem = getNavigationItem(accumulated, navigation);
//     const title = navItem?.title || segments[i];
//     crumbs.push({ title, url: accumulated });
//   }

//   // Optionally, add a Home root crumb
//   crumbs.unshift({ title: "Home", url: "/" });

//   return crumbs;
// }

// function PageBreadcrumb(props) {
//   const { className, ...rest } = props;
//   const location = useLocation();
//   const navigation = useSelector((state) => state.navigation);
//   // (Adjust the selector to point to your navigation config in Redux)

//   const crumbs = buildCrumbs(location.pathname, navigation);

//   return (
//     <Breadcrumbs
//       className={clsx("flex w-full", className)}
//       aria-label="breadcrumb"
//       {...rest}
//     >
//       {crumbs.map((item, idx) => {
//         const isLast = idx === crumbs.length - 1;
//         if (isLast) {
//           // Last crumb, render as Typography (not clickable)
//           return (
//             <Typography
//               key={idx}
//               className="block font-medium tracking-tight capitalize max-w-128 truncate"
//             >
//               {item.title}
//             </Typography>
//           );
//         } else {
//           return (
//             <Typography
//               key={idx}
//               component={Link}
//               to={item.url}
//               className="block font-medium tracking-tight capitalize max-w-128 truncate"
//             >
//               {item.title}
//             </Typography>
//           );
//         }
//       })}
//     </Breadcrumbs>
//   );
// }

// export default PageBreadcrumb;
